import React from "react";
import { Switch, Route } from "react-router-dom";

import { FEEDBACK_PAGE_PATH, PREFERENCES_BASE_PATH, DISAGG101_BASE_PATH } from "../../constants/paths";
import ErrorMain from "../common/Error/ErrorMain";
import PreferencesContainer from "./Preferences/PreferenceMain/PreferencesContainer";
import FeedbackStateDataWait from "./Feedback/FeedbackStateDataWait";
import DisaggMainContainer from "./Disagg/DisaggMain/DisaggMainContainer";

class StandaloneMain extends React.Component {
  render() {
    return (
      <Switch>
        <Route path={PREFERENCES_BASE_PATH} component={PreferencesContainer} />
        <Route exact path={FEEDBACK_PAGE_PATH} component={FeedbackStateDataWait} />
        <Route exact path={DISAGG101_BASE_PATH} component={DisaggMainContainer} />
        <Route component={ErrorMain} />
      </Switch>
    );
  }
}

export default StandaloneMain;
